import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../Buttons/Button';

class Collapse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: this.props.show,
    };
  }

  onClick = (e) => {
    e.preventDefault();
    e.currentTarget.blur();
    this.setState({ show: !this.state.show });
  }

  render() {
    const { trigger, content } = this.props;
    const { show } = this.state;

    const toggleClass = classNames('collapse', {
      'collapse--show': show,
      'collapse--no-content': content === null,
    });

    return (
      <div className={toggleClass}>
        <Button classes="collapse__trigger" onClick={this.onClick} faux>
          {trigger}
        </Button>
        {/* We use the .show class added to the container to show and hide */}
        <div className="collapse__content">{content}</div>
      </div>
    );
  }
}

Collapse.propTypes = {
  show: PropTypes.bool,
  trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
};

export default Collapse;



// WEBPACK FOOTER //
// ./library/app/components/Global/Collapse/Collapse.js